function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { cmsActions } from '../../reducers/cms.reducer';
import { modalActions } from '../../reducers/modal.reducer';
import useAppGroup from '../../helpers/hooks/useAppGroup';
import useEnvArr from '../../helpers/hooks/useEnvArr';
import Button from '../common/Button.react';
import Input from '../common/form/Input.react';
import Checkbox from '../common/form/Checkbox.react';
// import InputCalendar from '../common/form/InputCalendar.react';
import Label from '../common/form/Label.react';
import SelectInternalUrl from '../common/form/select/SelectInternalUrl.react';
import SelectPpcProduct from '../common/form/select/SelectPpcProduct.react';
import SelectPpcProductCategory from '../common/form/select/SelectPpcProductCategory.react';
import SelectPpcService from '../common/form/select/SelectPpcService.react';
import SelectPpcServiceCategory from '../common/form/select/SelectPpcServiceCategory.react';
import SelectPopup from '../common/form/select/SelectPopup.react';
import SelectPPCLocation from '../common/form/select/SelectPPCLocation.react';
import Card from '../common/card/Card.react';
import CardHeader from '../common/card/CardHeader.react';
import CardBody from '../common/card/CardBody.react';
import NavigationDeleteItem from './NavigationDeleteItem.react';
import NavigationAdd from './NavigationAdd.modal';
import NavigationSlot from './NavigationSlot.react';
var NavigationAddItem = function NavigationAddItem(_ref) {
  var _ref$route = _ref.route,
    route = _ref$route === void 0 ? 'dashboard' : _ref$route,
    navBarArr = _ref.navBarArr,
    navigationAction = _ref.navigationAction,
    addModalAction = _ref.addModalAction;
  var navigate = useNavigate();
  var _useParams = useParams(),
    app = _useParams.app,
    itemID = _useParams.itemID;
  var cmsEnvironments = useSelector(function (s) {
    return s.settings.constants.environments || [];
  });
  var cmsNavigation = useSelector(function (s) {
    return s.cms.navigation || {};
  });
  // const cmsPages = useSelector(s => s.pos.pages || {});
  var envArr = useEnvArr();
  var appGroup = useAppGroup({
    app: app
  });
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    form = _useState2[0],
    setForm = _useState2[1];
  var title = form.title,
    internalUrl = form.internalUrl,
    externalUrl = form.externalUrl,
    popup = form.popup,
    published = form.published,
    children = form.children;
  var getPublishedObj = function getPublishedObj(_ref2) {
    var published = _ref2.published;
    var returnObj = {};
    published.forEach(function (x) {
      if (x.isPublished) returnObj[x.clientEnv] = true;
    });
    return returnObj;
  };
  useEffect(function () {
    if (!itemID || !cmsNavigation[itemID]) {
      setForm({});
    } else {
      setForm(_objectSpread(_objectSpread({}, cmsNavigation[itemID]), {}, {
        published: getPublishedObj(cmsNavigation[itemID])
      }));
    }
  }, [app, itemID, cmsNavigation]);
  var updateForm = function updateForm(key, value) {
    return setForm(_objectSpread(_objectSpread({}, form), {}, _defineProperty({}, key, value)));
  };
  var isValid = function isValid() {
    return (title === null || title === void 0 ? void 0 : title.length) > 0;
  };
  var permissionKey = function permissionKey() {
    if (appGroup === 'pos') return 'edit-pos-navigation';else if (app === 'ppark') return 'edit-ppark-navigation';else if (app === 'construx') return 'edit-construx-navigation';
    return '';
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, itemID && cmsNavigation[itemID] ? /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: title,
    button: {
      label: 'New Tab',
      type: 'add',
      permission: permissionKey(),
      onClick: function onClick() {
        addModalAction({
          component: /*#__PURE__*/React.createElement(NavigationAdd, {
            app: app,
            navBarArr: navBarArr
          })
        });
      }
    }
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement("div", {
    className: "g-form"
  }, /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(Label, {
    label: "Nav Bar Name",
    required: true,
    info: "Title for your Navigation Link."
  }), /*#__PURE__*/React.createElement(Input, {
    value: title || '',
    onChange: function onChange(e) {
      return updateForm('title', e.target.value);
    },
    permission: permissionKey()
  })), /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(Label, {
    label: "Link to Section"
  }), /*#__PURE__*/React.createElement(SelectInternalUrl, {
    value: internalUrl || '',
    app: app,
    permission: permissionKey(),
    onChange: function onChange(internalUrl) {
      return updateForm('internalUrl', internalUrl);
    }
  })), appGroup === 'ppc' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(Label, {
    label: "Link to Product"
  }), /*#__PURE__*/React.createElement(SelectPpcProduct, {
    value: internalUrl || '',
    app: app,
    valueKey: "internalUrl",
    permission: permissionKey(),
    onChange: function onChange(internalUrl) {
      return updateForm('internalUrl', internalUrl);
    }
  })), /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(Label, {
    label: "Link to Product Category"
  }), /*#__PURE__*/React.createElement(SelectPpcProductCategory, {
    value: internalUrl || '',
    app: app,
    valueKey: "internalUrl",
    permission: permissionKey(),
    onChange: function onChange(internalUrl) {
      return updateForm('internalUrl', internalUrl);
    }
  })), /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(Label, {
    label: "Link to Service"
  }), /*#__PURE__*/React.createElement(SelectPpcService, {
    value: internalUrl || '',
    app: app,
    valueKey: "internalUrl",
    permission: permissionKey(),
    onChange: function onChange(internalUrl) {
      return updateForm('internalUrl', internalUrl);
    }
  })), /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(Label, {
    label: "Link to Service Category"
  }), /*#__PURE__*/React.createElement(SelectPpcServiceCategory, {
    value: internalUrl || '',
    app: app,
    valueKey: "internalUrl",
    permission: permissionKey(),
    onChange: function onChange(internalUrl) {
      return updateForm('internalUrl', internalUrl);
    }
  })), /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(Label, {
    label: "Link to Location"
  }), /*#__PURE__*/React.createElement(SelectPPCLocation, {
    value: internalUrl || '',
    app: app,
    permission: permissionKey(),
    onChange: function onChange(internalUrl) {
      return updateForm('internalUrl', internalUrl);
    }
  }))), /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(Label, {
    label: "External URL",
    info: "Link to an external site."
  }), /*#__PURE__*/React.createElement(Input, {
    value: externalUrl || '',
    onChange: function onChange(e) {
      return updateForm('externalUrl', e.target.value.replace(/ /g, ''));
    },
    permission: permissionKey()
  })), /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(Label, {
    label: "Show Popup",
    info: "Display a popup window."
  }), /*#__PURE__*/React.createElement(SelectPopup, {
    value: popup || '',
    app: app,
    permission: permissionKey(),
    onChange: function onChange(popup) {
      return updateForm('popup', popup);
    }
  })), /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(Label, {
    label: "Position"
  }), /*#__PURE__*/React.createElement(NavigationSlot, {
    selected: cmsNavigation[itemID],
    navArr: cmsNavigation
  })), /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(Label, {
    label: "Allow Sub-navigation"
  }), /*#__PURE__*/React.createElement(Checkbox, {
    checked: children,
    label: "Yes",
    onChange: function onChange() {
      return updateForm('children', true);
    },
    permission: permissionKey(),
    style: {
      display: 'inline-block',
      width: 'auto',
      marginRight: 30
    }
  }), /*#__PURE__*/React.createElement(Checkbox, {
    checked: !children,
    label: "No",
    onChange: function onChange() {
      return updateForm('children', false);
    },
    permission: permissionKey(),
    style: {
      display: 'inline-block',
      width: 'auto'
    }
  })), /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(Label, {
    label: "Publish"
  }), cmsEnvironments.filter(function (x) {
    return x.clientApp === app.toLowerCase() && envArr.includes(x.key);
  }).map(function (x) {
    return /*#__PURE__*/React.createElement(Checkbox, {
      checked: published ? published[x.key] : false,
      label: x.name,
      onChange: function onChange(v) {
        return updateForm('published', _objectSpread(_objectSpread({}, published), {}, _defineProperty({}, x.key, v)));
      },
      permission: permissionKey(),
      key: "published".concat(x.key)
    });
  }))), /*#__PURE__*/React.createElement("div", {
    className: "g-btn-row"
  }, /*#__PURE__*/React.createElement(Button, {
    label: "Save",
    onClick: function onClick() {
      navigationAction({
        formData: _objectSpread(_objectSpread({}, form), {}, {
          app: app,
          itemID: form._id
        }),
        method: 'put'
      });
    },
    disabled: !isValid(),
    permission: permissionKey()
  }), itemID && cmsNavigation[itemID] && /*#__PURE__*/React.createElement(Button, {
    label: "Cancel",
    onClick: function onClick() {
      if (route === 'dashboard') navigate("/".concat(app, "/dashboard"));else navigate("/".concat(app, "/").concat(route));
    },
    type: "cancel"
  }), /*#__PURE__*/React.createElement(NavigationDeleteItem, {
    item: cmsNavigation[itemID],
    permission: permissionKey()
  })))) : /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "No Tab Selected",
    button: {
      label: 'New Tab',
      type: 'add',
      permission: permissionKey(),
      onClick: function onClick() {
        addModalAction({
          component: /*#__PURE__*/React.createElement(NavigationAdd, {
            app: app,
            navBarArr: navBarArr
          })
        });
      }
    }
  })));
};
var mdtp = {
  navigationAction: cmsActions.navigation,
  addModalAction: modalActions.add
};
export default connect(null, mdtp)(NavigationAddItem);